// src/helpers/factories/menuIngredientCardFactory.ts
var menuIngredientCardFactory = (ingredients) => {
  return Object.values(ingredients).map((ingredient) => {
    const isActive = ingredient.active;
    return {
      id: Number(ingredient.ingredientId),
      title: ingredient.name,
      description: ingredient.posName,
      itemCount: ingredient.itemIds.length,
      isActive,
      activeFilter: isActive ? 1 : 2
    };
  });
};

export { menuIngredientCardFactory };
